import { render, staticRenderFns } from "./AdminStrainAddModal.vue?vue&type=template&id=27b13e35"
import script from "./AdminStrainAddModal.vue?vue&type=script&lang=js"
export * from "./AdminStrainAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b13e35')) {
      api.createRecord('27b13e35', component.options)
    } else {
      api.reload('27b13e35', component.options)
    }
    module.hot.accept("./AdminStrainAddModal.vue?vue&type=template&id=27b13e35", function () {
      api.rerender('27b13e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminStrainAddModal.vue"
export default component.exports